export const NAVIGATION = [
  {
    segment: "home",
    title: "Inicio",
    iconKey: "dashboard",
    home: { show: false }, // home card no, porque ya estás en home
  },
  {
    segment: "legalFileHome",
    title: "Expedientes",
    iconKey: "assignment",
    permission: "expediente",
    match: "prefix",
    home: {
      show: true,
      color: "#2563eb",
      description: "Gestión y administración de expedientes",
    },
    children: [
      {
        segment: "legalFile",
        title: "Gestionar",
        iconKey: "assignment",
        permission: "expediente",
        match: "exact",
        home: { show: false, color: "#2563eb" }, // si querés card directo a gestionar
      },
      {
        segment: "legalFile/news",
        title: "Novedades",
        iconKey: "newspaper",
        permission: "novedades",
        match: "prefix",
        home: {
          show: true,
          color: "#0ea5e9",
          description: "Gestión y administración de Novedades",
        },
      },
      {
        segment: "legalFile/attachments",
        title: "Escritos",
        iconKey: "attachment",
        permission: "archivos adjuntos expedientes",
        match: "prefix",
        home: { show: false, color: "#64748b" },
      },
      {
        segment: "legalFile/documents",
        title: "Adjuntos",
        iconKey: "documents",
        permission: "ver documentos expedientes",
        match: "prefix",
        home: {
          show: true,
          color: "#f59e0b",
          description: "Documentos cargados en los expedientes",
        },
      },
      {
        segment: "legalFile/parties",
        title: "Partes y Clientes",
        iconKey: "parties",
        permission: "partes legales",
        match: "prefix",
        home: {
          show: true,
          color: "#4a78b9",
          description: "Partes legales y clientes agrupados",
        },
      },
      {
        segment: "legalFile/judicial/accounts",
        title: "Cuentas Judiciales",
        iconKey: "judicialAccounts",
        permission: "cuentas judiciales",
        match: "prefix",
        home: {
          show: true,
          color: "#379a57",
          description: "Gestión y administración cuentas judiciales",
        },
      },
      {
        segment: "legalFile/notification/certificates",
        title: "Cedulas de Notificación",
        iconKey: "certificatesNotifications",
        permission: "cedulas notificacion",
        match: "prefix",
        home: {
          show: true,
          color: "#3ba5a5",
          description: "Gestión y administración cedulas de notificación",
        },
      },
      {
        segment: "legalFile/report/menu",
        title: "Reportes",
        iconKey: "fileOpen",
        permission: "reporte",
        match: "prefix",
        home: { show: false, color: "#8b5cf6" },
      },
    ],
  },

  {
    segment: "workspace",
    title: "Área de Trabajo",
    iconKey: "workspace",
    permission: "area de trabajo",
    match: "prefix",
    home: {
      show: true,
      color: "#f97316",
      description: "Tareas y expedientes de trabajo del equipo",
    },
  },
  {
    segment: "liquidations",
    title: "Liquidaciones",
    iconKey: "liquidations",
    permission: "liquidaciones",
    match: "prefix",
    home: {
      show: true,
      color: "#7c3aed",
      description: "Gestión y administración de liquidaciones",
    },
  },
  {
    segment: "paymentOrder",
    title: "Órdenes de Pago",
    iconKey: "requestQuote",
    permission: "orden de pago",
    home: {
      show: true,
      color: "#f59e0b",
      description: "Gestión y administración de ordenes de pago",
    },
  },
  {
    segment: "lawsuit",
    title: "Títulos Electrónicos",
    iconKey: "lawsuit",
    permission: "demandas",
    home: {
      show: true,
      color: "#ef4444",
      description: "Gestión y administración de títulos electrónicos",
    },
  },
  {
    segment: "lawyer",
    title: "Abogados",
    iconKey: "emojiPeople",
    permission: "abogado",
    home: {
      show: true,
      color: "#10b981",
      description: "Gestión y administración de abogados",
    },
  },
  {
    segment: "contributors/arca",
    title: "ARCA",
    iconKey: "accountBalance",
    permission: "arca",
    home: {
      show: false,
      color: "#0ea5e9",
      description: "Gestión y administración de contribuyentes ARCA",
    },
  },
  {
    segment: "user",
    title: "Usuarios",
    iconKey: "groups",
    permission: "usuario",
    home: {
      show: true,
      color: "#64748b",
      description: "Gestión y administración de usuarios",
    },
  },
  {
    segment: "security",
    title: "Seguridad",
    iconKey: "adminPanel",
    permission: "seguridad",
    home: {
      show: true,
      color: "#22c55e",
      description: "Gestión y administración de roles y permisos",
    },
  },
  {
    segment: "settings",
    title: "Configuración",
    iconKey: "settings",
    permission: "configuracion",
    home: { show: false }, // normalmente no lo querés en home
  },
];
